import axios from "axios";
import swal from "sweetalert2";

import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { globalState, accessTokenKey, baseUrl } from "../utils/config";

function ForgotPassword() {

    const navigate = useNavigate();
    const [submitting, setSubmitting] = useState(false);

    async function sendRecoveryLink() {
        setSubmitting(true);

        try {
            const form = document.getElementById("form-send-recovery-link");
            const formData = new FormData(form);

            const response = await axios.post(
                baseUrl + "/api/send-password-reset-link",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                swal.fire("Reset password", response.data.message, "success")
                    .then(function () {
                        navigate("/reset-password/" + form.email.value);
                    });
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <>
            <div className="container-xxl py-5 bg-dark page-header mb-5">
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">Forgot password</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/login">Login</Link></li>
                            <li className="breadcrumb-item text-white active" aria-current="page">Forgot password</li>
                        </ol>
                    </nav>
                </div>
            </div>

             <div className="container-xxl py-5">
                <div className="container">
                    <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">Forgot password</h1>
                    <div className="row g-4">
                        <div className="col-md-12">
                            <div className="wow fadeInUp" data-wow-delay="0.5s">
                                <p className="mb-5 text-center">Enter the email address associated with your account, and we'll send you a recovery link to reset your password and regain access.</p>

                                <form onSubmit={ function (event) {
                                    event.preventDefault();
                                    sendRecoveryLink();
                                } } id="form-send-recovery-link">
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <div className="form-floating">
                                                <input type="email" className="form-control" name="email" placeholder="Email" required />
                                                <label>Email</label>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <button className="btn btn-primary w-100 py-3" type="submit"
                                                disabled={ submitting }>Send recovery link</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ForgotPassword;